function getObjectProperty(source: unknown, key: string): unknown {
  if (!source || typeof source !== 'object') {
    return undefined;
  }

  const record = source as Record<string, unknown>;
  if (key in record) {
    return record[key];
  }

  const lowerKey = key.toLowerCase();
  const matchedKey = Object.keys(record).find(existingKey => existingKey.toLowerCase() === lowerKey);
  return matchedKey ? record[matchedKey] : undefined;
}

export function isFilledResultValue(value: unknown): boolean {
  if (value == null) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some(item => {
      if (item && typeof item === 'object') {
        return Object.values(item as Record<string, unknown>).some(inner => isFilledResultValue(inner));
      }
      return isFilledResultValue(item);
    });
  }

  if (typeof value === 'string') {
    const text = value.trim();
    return text !== '' && text !== '-' && text !== '[]' && text !== 'null';
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return true;
  }

  if (typeof value === 'object') {
    return Object.values(value as Record<string, unknown>).some(inner => isFilledResultValue(inner));
  }

  return false;
}

export function controlHasFilledResult(control: unknown): boolean {
  return isFilledResultValue(getObjectProperty(control, 'resultValues'));
}

export function stepHasFilledResults(step: unknown): boolean {
  const controls = getObjectProperty(step, 'controls');
  return Array.isArray(controls) && controls.some(controlHasFilledResult);
}

export function blockHasFilledResults(block: unknown): boolean {
  const controls = getObjectProperty(block, 'controls');
  if (Array.isArray(controls) && controls.some(controlHasFilledResult)) {
    return true;
  }

  const steps = getObjectProperty(block, 'steps');
  return Array.isArray(steps) && steps.some(stepHasFilledResults);
}
